import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash, faUser} from "@fortawesome/free-solid-svg-icons";
import {
    ADMIN_GET_USER
} from "../../../queries/queries";
import {useLazyQuery} from "@apollo/client";
import {Spinner} from "reactstrap";


const AdminUserShow = () => {

    const params = useParams();
    const [user, setUser] = useState();
    const [showPassword, setShowPassword] = useState(false);
    const [showLog, setShowLog] = useState(false);
    const [loading, setLoading] = useState(false);

    // const [getAllUsers, {loading, refetch}] = useLazyQuery(ADMIN_GET_USER, {
    //     variables: {
    //         id: parseInt(params.id)
    //     },
    //     fetchPolicy: 'cache-and-network',
    //     onCompleted: (e) => {
    //         console.log(e.adminGetUser);
    //         setUser(e.adminGetUser);
    //     },
    //     onError: () => console.log("API Request failed - if this keeps happening, report to developer!")
    // });

    const toggleShowCryptoWallets = () =>{
        setShowPassword(!showPassword);
    }
    const toggleShowLog = () =>{
        setShowLog(!showLog);
    }

    useEffect(() => {
        // getAllUsers();
    }, []);

    return (

        <div className="card text-bg-dark">
            {user && <>
                <div className="card-header d-flex justify-content-between align-items-center">
                    {user.displayName}
                </div>

                <div className="card-body p-0">
                    <div className="card">
                        <div className="card-body">

                            <div className="mb-3">
                                <label className="form-label">Display Name</label>
                                <input type="text" className="form-control" readOnly={true}
                                       defaultValue={user.displayName}/>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label className="form-label">Coins</label>
                                        <input type="text" className="form-control" readOnly={true}
                                               defaultValue={user.coins} secure/>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="mb-3">
                                        <label className="form-label">Kick account</label>
                                        <input type="text" className="form-control" readOnly={true}
                                               defaultValue={user.connectionName} />
                                    </div>
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">ETH-Address {showPassword ?
                                    <FontAwesomeIcon icon={faEyeSlash} onClick={toggleShowCryptoWallets}/> :
                                    <FontAwesomeIcon icon={faEye} onClick={toggleShowCryptoWallets}/>}</label>
                                <input className="form-control" readOnly={true}
                                       type={
                                           showPassword ? "text" : "password"
                                       }
                                       defaultValue={user.ethAddress} />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">BTC-Address {showPassword ? <FontAwesomeIcon icon={faEyeSlash} onClick={toggleShowCryptoWallets}/> : <FontAwesomeIcon icon={faEye} onClick={toggleShowCryptoWallets}/>}</label>
                                <input className="form-control" readOnly={true}
                                       type={
                                           showPassword ? "text" : "password"
                                       }
                                       defaultValue={user.btcAddress} />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">LTC-Address {showPassword ? <FontAwesomeIcon icon={faEyeSlash} onClick={toggleShowCryptoWallets}/> : <FontAwesomeIcon icon={faEye} onClick={toggleShowCryptoWallets}/>}</label>
                                <input className="form-control" readOnly={true}
                                       type={
                                           showPassword ? "text" : "password"
                                       }
                                       defaultValue={user.ltcAddress} />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">USDT-Address {showPassword ? <FontAwesomeIcon icon={faEyeSlash} onClick={toggleShowCryptoWallets}/> : <FontAwesomeIcon icon={faEye} onClick={toggleShowCryptoWallets}/>}</label>
                                <input className="form-control" readOnly={true}
                                       type={
                                           showPassword ? "text" : "password"
                                       }
                                       defaultValue={user.usdtAddress} />
                            </div>

                            <div className="mb-3">
                                <h3>Activity log (DO NOT REVEAL ON STREAM!) {showLog ? <FontAwesomeIcon icon={faEyeSlash} onClick={toggleShowLog}/> : <FontAwesomeIcon icon={faEye} onClick={toggleShowLog}/>}</h3>

                                {showLog &&<table className="table table-dark table-striped">
                                    <thead>
                                    <tr>
                                        <th>
                                            #
                                        </th>
                                        <th>
                                            Action
                                        </th>
                                        <th>
                                            Description
                                        </th>
                                        <th>
                                            IP
                                        </th>
                                    </tr>
                                    </thead>
                                    {loading ? (<Spinner/>) : (
                                        <tbody>
                                        {user.Activities && user.Activities.length > 0 ? (
                                            <>
                                                {user.Activities.map((row, index) => {
                                                    return (<tr>
                                                        <th scope="row">
                                                            {row?.id}
                                                        </th>
                                                        <td>
                                                            {row?.action}
                                                        </td>
                                                        <td>
                                                            {row?.description}
                                                        </td>
                                                        <td>
                                                            {row.ipAddress}
                                                        </td>
                                                    </tr>);
                                                })}
                                            </>
                                        ) : (<></>)}

                                        </tbody>
                                    )}
                                </table>}

                            </div>

                        </div>
                    </div>
                </div>
            </>}
        </div>
    );

};

export default AdminUserShow;